import React, { useEffect, useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import SideBarSkeleton from "../../Component/SideBarSkeleton";
import { thumbnail } from "../../constant/imagePath";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import CloudDownloadIcon from "@mui/icons-material/CloudDownload";
import classes from "./VideoDetails.module.css";
import { Button } from "../../Component/Button/Button";
import RescheduleModal from "../../modals/RescheduleModal";
import EditVideo from "../../modals/EditVideo";
import AreYouSureModal from "../../modals/AreYouSureModal";
import { Delete, Get, Patch } from "../../Axios/AxiosFunctions";
import {
  apiHeader,
  BaseURL,
  endpointsUrl,
  imageUrl,
  recordsLimit,
} from "../../config/apiUrl";
import { useSelector } from "react-redux";
import { Loader } from "../../Component/Loader";
import ReactPlayer from "react-player";
import { BsFillPlayFill } from "react-icons/bs";
import ViewVideoModal from "../../modals/ViewVideoModal";
import moment from "moment";
import EditVideoModal from "../../modals/EditVideoModal";
import axios from "axios";
import { toast } from "react-toastify";
import { useParams } from "react-router-dom";
import ShowMoreShowLessText from "../../Component/ShowMoreShowLess/ShowMoreShowLessText";
const VideoDetails = () => {
  const [show, setShow] = useState(false);
  const [responseData, setResponseData] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const { access_token, user } = useSelector((state) => state?.authReducer);
  const [selectedItem, setSelectedItem] = useState(null);
  const [videFile, setVideFile] = useState(null);
  const [isLoadingEdit, setIsLoadingEdit] = useState(false);
  const [videoProgress, setVideoProgress] = useState(0);
  const [thumbnailPicture, setThumbnailPicture] = useState(null);
  const [deleteLoading, setDeleteLoading] = useState(false);

  // Pagination
  const [pageNo, setPageNo] = useState(1);
  const [totalRecords, setTotalRecords] = useState(0);

  const { id } = useParams();

  const getData = async (pg = pageNo) => {
    setIsLoading(true);
    const response = await Get(BaseURL(`video/${id}`), access_token);
    setIsLoading(false);

    if (response) {
      setResponseData(response?.data?.data);
      setTotalRecords(response?.data?.totalRecords);
    }
  };
  useEffect(() => {
    getData();
  }, [pageNo]);
  const handleEdit = async (data) => {
    const formData = new FormData();
    for (var key in data) {
      formData.append(key, data[key]);
    }
    setIsLoadingEdit(true);

    const response = await Patch(
      BaseURL(`video/${data?._id}`),
      formData,
      apiHeader(access_token)
    );

    if (response != undefined) {
      setResponseData(response?.data?.data?.doc);

      !!response?.data?.data?.url &&
        (await axios
          .put(response?.data?.data?.url, videFile, {
            headers: {
              "Content-Type": videFile?.type,
            },
            onUploadProgress: (data) => {
              setVideoProgress(Math.round((100 * data.loaded) / data.total));
            },
          })
          .then(() => {
            getData();
            setVideoProgress(0);
          })
          .catch(async () => {
            const url = BaseURL(`video/${response?.data?.data?._id}`);
            const response = await Delete(url, null, apiHeader(access_token));
            if (response) {
              console.log("Video deleted");
            }
          }));
      setVideoProgress(0);

      setIsLoadingEdit(false);

      toast.success("Video uploaded successfully");
      // navigate(-1);

      setShow(false);
    }
  };

  const deleteVideo = async () => {
    const url = BaseURL(`video/${selectedItem?._id}`);
    setDeleteLoading(true);
    const response = await Delete(url, null, apiHeader(access_token));
    if (response) {
      console.log("Video deleted");
      const newData = [...responseData];
      newData?.splice(
        newData?.findIndex((item) => item?._id == selectedItem?._id),
        1
      );
      setResponseData(newData);
      toast.success("Video Succesfully Deleted");
    }
    setDeleteLoading(false);
    setShow("");
  };

  return (
    <>
      <SideBarSkeleton>
        <Col md={12} className={classes.vid_detail_head}>
          <h3>Videos Detail</h3>
        </Col>
        <Container className={`custom_conti_b ${classes.pageContent}`}>
          <Row
            style={{
              justifyContent: "center",
            }}
          >
            {isLoading ? (
              <Loader className={classes.loader} />
            ) : (
              <Col md={5} lg={5}>
                <div className="mb-5">
                  <div className={classes.image_div}>
                    <ReactPlayer
                      width={"100%"}
                      height={"100%"}
                      light={
                        <img
                          src={imageUrl(responseData?.thumbnail)}
                          alt="Thumbnail"
                        />
                      }
                      url={
                        !!responseData?.gallery
                          ? responseData?.gallery?.video
                          : responseData?.video
                      }
                      // controls={true}
                    />
                    <div
                      className={classes.playIconDiv}
                      onClick={() => {
                        setSelectedItem(responseData);
                        setShow("Video");
                      }}
                    >
                      <BsFillPlayFill size={25} />
                    </div>
                  </div>
                  <div>
                    <div className={classes.name_div}>
                      <div className={classes.heading_channel}>
                        <h4>{responseData?.channel?.instagramId}</h4>
                      </div>
                      <div className={classes.icon_main_div}>
                        {responseData?.status !== "uploaded" && (
                          <div
                            onClick={() => {
                              setSelectedItem({ ...responseData });

                              setShow("Edit");
                            }}
                          >
                            <EditIcon />
                          </div>
                        )}
                        {responseData?.status !== "uploaded" && (
                          <div
                            style={{ cursor: "pointer" }}
                            onClick={() => {
                              setSelectedItem(responseData);

                              setShow("Delete");
                            }}
                          >
                            <DeleteIcon />
                          </div>
                        )}
                        {responseData?.status !== "uploaded" && (
                          <div
                            onClick={() => {
                              setSelectedItem({ ...responseData });

                              setShow("ediTVideo");
                            }}
                          >
                            <CloudDownloadIcon />
                          </div>
                        )}
                      </div>
                    </div>
                    <div>
                      <p>
                        <b>Description: </b>
                        <ShowMoreShowLessText
                          text={responseData?.description}
                        />
                      </p>
                      <p>
                        <b>Uploaded By: </b>
                        {responseData?.uploadedBy?.email}
                      </p>
                      <p className="t-t-c">
                        <b>Status: </b>
                        {responseData?.status}
                      </p>
                      <div className={classes.date_div}>
                        <b>
                          Date :{" "}
                          {moment(responseData?.scheduledDate).format(
                            "MM/DD/YYYY"
                          )}
                        </b>
                        <b>
                          Time : /{" "}
                          {moment(responseData?.scheduledDate).format("h:mm A")}
                        </b>
                      </div>
                      {responseData?.status !== "uploaded" && (
                        <div className={classes.schedule_btns}>
                          <Button
                            onClick={() => {
                              setSelectedItem({ ...responseData });

                              setShow("Rescheduled");
                            }}
                            label={"Rescheduled"}
                          />
                          {/* <Button green onClick={() => {}} label={"View"} /> */}
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </Col>
            )}
          </Row>
        </Container>
      </SideBarSkeleton>
      {show == "Delete" && (
        <AreYouSureModal
          subTitle={"Are You Sure You Want To Delete This Member ?"}
          show={show == "Delete"}
          setShow={setShow}
          isApiCall={deleteLoading}
          onClick={deleteVideo}
        />
      )}
      {show == "Rescheduled" && (
        <RescheduleModal
          handleEdit={handleEdit}
          selectedItem={selectedItem}
          show={show == "Rescheduled"}
          setShow={setShow}
        />
      )}
      {show == "ediTVideo" && (
        <EditVideoModal
          handleEdit={handleEdit}
          selectedItem={selectedItem}
          width="1289px"
          show={show == "ediTVideo"}
          setShow={setShow}
          setVideFile={setVideFile}
          thumbnailPicture={thumbnailPicture}
          videoProgress={videoProgress}
          videFile={videFile}
          isLoadingEdit={isLoadingEdit}
          setThumbnailPicture={setThumbnailPicture}
        />
      )}
      {show == "Edit" && (
        <EditVideo
          handleEdit={handleEdit}
          selectedItem={selectedItem}
          width="1289px"
          show={show == "Edit"}
          setShow={setShow}
        />
      )}
      {show == "Video" && (
        <ViewVideoModal
          selectedItem={selectedItem}
          show={show == "Video"}
          setShow={setShow}
          data={selectedItem}
        />
      )}
    </>
  );
};

export default VideoDetails;
